const Storage = {
  set: (key, value) => localStorage.setItem(key, JSON.stringify(value)),
  remove: (key) => localStorage.removeItem(key),
  get: (key) => JSON.parse(localStorage.getItem(key)),
};

export default Storage;
